/**
 * Os números das planilhas das escolas no menu — spec 0111 (FR-026, DD-18) e 0112 (FR-007).
 *
 * Dois números de uma leitura só: as pendências de aluno, na aba da fila, e as
 * planilhas que pedem ação, na aba delas. O módulo soma os dois.
 *
 * Segunda fonte do setor Corporativo, ao lado da do Feedback: as chaves se
 * somam no registro. Lê a cada minuto, só com a aba do navegador visível, e a
 * casca a registra só para quem vê a tela: para os outros, a rota daria 403.
 */
import { registrarFonteDeContadores } from '../../../../config/contadores';
import { lerContador } from './api';

const INTERVALO_MS = 60_000;

let numeros = { abertas: 0, planilhas: 0 };
let ligados = 0;
let relogio: number | undefined;
const avisos = new Set<() => void>();
let registrado = false;

async function ler(): Promise<void> {
  if (document.visibilityState !== 'visible') return;
  try {
    const n = await lerContador();
    if (n.abertas !== numeros.abertas || n.planilhas !== numeros.planilhas) {
      numeros = { abertas: n.abertas, planilhas: n.planilhas };
      avisos.forEach((a) => a());
    }
  } catch {
    // Sem número é melhor que número errado: fica o da última leitura.
  }
}

/** Uma decisão mudou a fila: lê de novo agora, sem esperar o minuto. */
export function releContadorDasPlanilhas(): void {
  if (registrado) void ler();
}

export function registrarFonteDasPlanilhas(): void {
  if (registrado) return;
  registrado = true;
  registrarFonteDeContadores('corporativo', {
    ler: () => ({ planilhas: numeros.planilhas, pendenciasDasPlanilhas: numeros.abertas }),
    assinar: (aviso) => { avisos.add(aviso); return () => { avisos.delete(aviso); }; },
    ligar: () => {
      ligados += 1;
      if (ligados === 1) {
        void ler();
        relogio = window.setInterval(() => { void ler(); }, INTERVALO_MS);
      }
      return () => {
        ligados -= 1;
        if (ligados === 0 && relogio !== undefined) { window.clearInterval(relogio); relogio = undefined; }
      };
    },
  }, 'planilhas');
}
